import { useEffect } from 'react';
import { Linking, Platform } from 'react-native';
import {
  flushPendingDeepLink,
  handleIncomingDeepLinkUrl,
} from './deepLinkRouter';

export const useDeepLinkListener = (isAuthenticated: boolean) => {
  useEffect(() => {
    if (Platform.OS === 'web') return undefined;

    let remove: (() => void) | undefined;
    let cancelled = false;

    void (async () => {
      const initialUrl = await Linking.getInitialURL();
      if (cancelled) return;
      if (initialUrl) {
        await handleIncomingDeepLinkUrl(initialUrl);
      }
      const subscription = Linking.addEventListener('url', event => {
        void handleIncomingDeepLinkUrl(event.url);
      });
      remove = () => subscription.remove();
    })();

    return () => {
      cancelled = true;
      remove?.();
    };
  }, []);

  useEffect(() => {
    if (Platform.OS === 'web' || !isAuthenticated) return;
    void flushPendingDeepLink();
  }, [isAuthenticated]);
};
